import '../shared/polyfills'

import * as Sentry from '@sentry/browser'
import { Provider } from 'mobx-react'
import * as React from 'react'
import { render } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '../shared/styled-components'
import { Theme } from '../shared/Theme'
import Calculator from './components/Calculator'
import { Config } from '../shared/Config'
import * as ReactGA from 'react-ga'

if ((module as any).hot) {
  ;(module as any).hot.accept(() => {
    setTimeout(() => window.location.reload(), 1000)
  })
}

//@ts-ignore
ReactGA.initialize('UA-153291185-1', {
  gaOptions: {
    anonymizeIp: true
  }
})

export interface CalculatorOptions {
  theme?: typeof Theme
  apiKey?: number
  multiplier?: number
};

(window as any).ImplacheckCalculator = class ImplacheckCalculator {
  private _container: HTMLElement

  constructor (container: HTMLElement, options: CalculatorOptions = {}) {
    Sentry.init({ dsn: Config.sentryDSN });

    this._container = container

    render(<Provider options={options}>
      <ThemeProvider theme={Object.assign({}, Theme, options.theme || {})}>
        <BrowserRouter>
          <Calculator />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>, this._container)
  }
}
